import { render, staticRenderFns } from "./cargo-item.vue?vue&type=template&id=7d5c0704&scoped=true"
import script from "./cargo-item.vue?vue&type=script&lang=js"
export * from "./cargo-item.vue?vue&type=script&lang=js"
import style0 from "./cargo-item.vue?vue&type=style&index=0&id=7d5c0704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5c0704",
  null
  
)

export default component.exports